<template>
  <div :style="styles" class="adm-tabs-glider" />
</template>

<script>
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  props: {
    position: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { position, width } = toRefs(props);

    const styles = computed(() => ({
      transform: `translateX(${position.value || 0}px)`,
      width: `${width.value || 0}px`,
    }));

    return { styles };
  },
});
</script>
